"use client";

import { createContext, useContext, useState, useCallback, lazy, Suspense, type ReactNode } from "react";

const ContactFormModal = lazy(() => import("@/components/forms/ContactFormModal"));

interface ContactFormContext {
  openContactForm: () => void;
}

const Ctx = createContext<ContactFormContext>({
  openContactForm: () => {},
});

export function useContactForm() {
  return useContext(Ctx);
}

export default function ContactFormProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  const openContactForm = useCallback(() => setOpen(true), []);
  const onClose = useCallback(() => setOpen(false), []);

  return (
    <Ctx value={{ openContactForm }}>
      {children}
      {open && (
        <Suspense>
          <ContactFormModal open={open} onClose={onClose} />
        </Suspense>
      )}
    </Ctx>
  );
}
